<template>
  <article>
    <h1>{{ detailData.title }}</h1>
    <address>
      发布时间：<span>{{ detailData.ctime | formatDate('yyyy-MM-dd') }}</span
      >&nbsp;&nbsp;|&nbsp;&nbsp; 作者：<span>{{ detailData.mainWriter }}</span
      >&nbsp;&nbsp;&nbsp;&nbsp; 来源：<span>{{ detailData.mainAuthor }}</span>
    </address>
    <div class="policy-content" v-html="detailData.contents"></div>
    <div class="text-center">
      <el-button type="primary" @click="back"> 返回 </el-button>
    </div>
  </article>
</template>

<script>
export default {
  name: 'policyDetail',
  props: {
    detailData: {
      type: Object,
      default() {
        return {};
      },
    },
  },
  mounted() {
    this.text();
  },
  methods: {
    back() {
      this.$emit('back');
    },
    text() {
      if (this.isBase64(this.detailData.contents)) {
        this.detailData.contents = this.decode(this.detailData.contents);
      }
    },
    isBase64(str) {
      if (str === '' || str.trim() === '') {
        return false;
      }
      try {
        return btoa(atob(str)) == str;
      } catch (err) {
        return false;
      }
    },
    encode(str) {
      return btoa(
        encodeURIComponent(str).replace(/%([0-9A-F]{2})/g, function toSolidBytes(match, p1) {
          return String.fromCharCode('0x' + p1);
        })
      );
    },
    //解密
    decode(str) {
      return decodeURIComponent(
        atob(str)
          .split('')
          .map(function (c) {
            return '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2);
          })
          .join('')
      );
    },
  },
};
</script>

<style scoped lang="scss">
h1 {
  margin: 20px 0;
}
.policy-content {
  margin: 20px 0;
  line-height: 1.7;
}
p {
  margin: 0 0 10px;
}
</style>
